module.exports = __webpack_public_path__ + "static/media/International_PechaKucha_Day.cbc79ca8.png";